<template>
  <footer class="mt-auto overflow-hidden">
    <v-sheet color="#76C043" class="py-10 py-md-12 item">
      <div class="container">
        <v-row
          justify="center"
          justify-md="space-around"
          justify-lg="space-between"
        >
          <v-col cols="12" md="3" class="text-center text-md-left">
            <router-link to="/">
              <img
                src="../../assets/img/hospital-dois-pinheiros.png"
                :alt="informations.name"
                class="d-inline-block item-brand filter-white"
                height="118px"
              />
            </router-link>
          </v-col>

          <v-col cols="11" sm="7" md="5" lg="auto">
            <div
              class="white--text font-weight-bold font-montserrat item-title"
            >
              CONTATO
            </div>

            <div class="d-flex flex-column">
              <div
                v-for="(contactItem, contactKey) in contact"
                :key="contactKey"
              >
                <div class="mx-n3" v-if="!Array.isArray(contactItem)">
                  <a
                    v-ripple
                    class="
                      white--text
                      d-inline-flex
                      text-none text-decoration-none
                      px-3
                      py-2
                    "
                    :href="contactItem.link"
                    :target="contactItem.target"
                  >
                    <v-sheet
                      color="transparent"
                      width="20px"
                      class="mr-2 text-center"
                    >
                      <v-icon class="white--text" :size="contactItem.size">
                        {{ contactItem.icon }}
                      </v-icon>
                    </v-sheet>

                    <span class="font-montserrat font-weight-bold">
                      {{ contactItem.title }}
                    </span>
                  </a>
                </div>
                <div v-else>
                  <div
                    class="mx-n3"
                    v-for="(
                      { title, link, target, icon, size }, key
                    ) in contactItem"
                    :key="key"
                  >
                    <a
                      v-ripple
                      class="
                        white--text
                        d-inline-flex
                        text-none text-decoration-none
                        px-3
                        py-2
                      "
                      :href="link"
                      :target="target"
                    >
                      <v-sheet
                        color="transparent"
                        width="20px"
                        class="mr-2 text-center"
                      >
                        <v-icon class="white--text" :size="size">
                          {{ icon }}
                        </v-icon>
                      </v-sheet>
                      <span
                        class="font-montserrat font-weight-bold"
                        v-html="title"
                      >
                        {{ title }}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div class="mx-n3">
                  <a
                    v-ripple
                    href="/politica-de-privacidade"
                    target="_blank"
                    class="
                      d-inline-flex
                      white--text
                      text-none text-decoration-none
                      px-3
                      py-2
                      item-link
                    "
                  >
                    <v-sheet
                      color="transparent"
                      width="20px"
                      class="mr-2 text-center"
                    >
                      <v-icon class="white--text" size="18"> fa-shield </v-icon>
                    </v-sheet>

                    <span class="font-montserrat white--text">
                      Política de Privacidade
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </v-col>

          <v-col
            cols="12"
            sm="5"
            md="3"
            class="
              d-flex
              align-center align-sm-end
              flex-column
              justify-space-between
            "
          >
            <div>
              <v-btn
                rounded
                depressed
                height="42px"
                min-width="auto"
                width="42px"
                :href="link"
                target="_blank"
                color="#00567C"
                class="white--text"
                :class="{ 'ml-3': keySocial > 0 }"
                :title="title"
                v-for="({ title, link, icon, size }, keySocial) in media"
                :key="keySocial"
              >
                <v-icon :size="size"> {{ icon }} </v-icon>
              </v-btn>
            </div>

            <a href="https://mrxweb.com.br/" target="_blank">
              <img
                class="mx-auto mx-sm-0 mt-6 mb-2 d-block"
                src="/img/mrxweb.svg"
                height="20px"
                alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
                title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
              />
            </a>
          </v-col>
        </v-row>
      </div>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact, getSocial } from "../../../config";

export default {
  computed: {
    informations() {
      return this.$rest("informationsAngels").item;
    },
    contacts() {
      return this.$rest("informationsAngels").item;
    },
    media() {
      return getSocial(this.informations);
    },
    contact() {
      return getContact(this);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  @media screen and (max-width: 1199px) {
    max-width: 100% !important;
  }
}

.item {
  &-brand {
    max-width: 100%;
    object-fit: contain;
    -o-object-fit: contain;
  }

  &-link {
    white-space: pre-wrap !important;

    span {
      margin-top: 2px;
    }
  }

  &-title {
    font-size: 18px;
    line-height: 22px;
  }
}
</style>
